import React from 'react';
import { ConsentGateView } from './ConsentGateView';

/**
 * CORE-1404 — веб: документы открываются маршрутом /legal/:docId в новой вкладке,
 * чтобы не уходить с обязательного экрана согласия.
 */
export const ConsentGate: React.FC = () => (
  <ConsentGateView
    onOpenDoc={(doc) => {
      if (typeof window !== 'undefined') window.open(`/legal/${doc}`, '_blank', 'noopener');
    }}
  />
);
